import { render, staticRenderFns } from "./ActivityLog.vue?vue&type=template&id=bfb8cc70&scoped=true"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"
import style0 from "./ActivityLog.vue?vue&type=style&index=0&id=bfb8cc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb8cc70",
  null
  
)

export default component.exports